import laundriesService from "api/laundriesService";
import { useMutation } from "react-query";

const useDeleteLaundryHolidayMutation = () => {
  return useMutation(async (laundryId: number) => {
    try {
      const res = await laundriesService.deleteLaundryHoliday(laundryId)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }) 
}

export default useDeleteLaundryHolidayMutation